import PropTypes from 'prop-types';
import {useFeatureFlag} from '../../hooks/useFeatureFlag.js';

const FeatureFlag = ({code, disabled = false, fallback = null, children}) => {
  const isVisible = useFeatureFlag(code);

  return isVisible !== disabled ? children : fallback;
};

FeatureFlag.propTypes = {
  code: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  fallback: PropTypes.node,
  children: PropTypes.node,
};

export default FeatureFlag;
